/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { Message, Form, Icon } from 'semantic-ui-react';

type Props = {
  block: EditorialYoutubeBlock,
};

const Render = ({ block }: Props) => {
  if (block.page) {
    return (
      <Form>
        <Form.Input
          iconPosition="left"
          label="Liaison vers la page"
          defaultValue={block.page.name}
          readOnly
          action
        >
          <Icon name="chevron right" />
          <input />
          <Link
            to={`pages/${block.page.id}`}
            target="innoctopus"
            className="ui button"
          >
            Editer
          </Link>
        </Form.Input>
      </Form>
    );
  }

  return <Message icon="info" header="Aucune page spécifiée" />;
};

export default Render;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/page/Render.js